export default function (state) {
    state.items = [];
    state.loading = false;
    state.tab = 'main';
}